import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFulfilmentActivityCompleted } from "../../../store/actions/fulfilments/activities";
import { displaySuccessToast } from "../../../store/actions/overflowNotification";
import "./style.css";

const VaporTimeline = props => {
  const { items, reloadData, customerId } = props;

  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);

  useEffect(() => {
    setLines();
  }, [items]);

  const adjustLine = (
    from, to, line
  ) => {
    var fT = from.offsetTop + from.offsetHeight / 2;
    var tT = to.offsetTop + to.offsetHeight / 2;
    var fL = from.offsetLeft + from.offsetWidth / 2;
    var tL = to.offsetLeft + to.offsetWidth / 2;

    var CA = Math.abs(tT - fT);
    var CO = Math.abs(tL - fL);
    var H = Math.sqrt(CA * CA + CO * CO);
    var ANG = (180 / Math.PI) * Math.acos(CA / H);

    let top;
    let left;

    if (tT > fT) {
      top = (tT - fT) / 2 + fT;
    } else {
      top = (fT - tT) / 2 + tT;
    }
    if (tL > fL) {
      left = (tL - fL) / 2 + fL;
    } else {
      left = (fL - tL) / 2 + tL;
    }

    if (
      (fT < tT && fL < tL) ||
      (tT < fT && tL < fL) ||
      (fT > tT && fL > tL) ||
      (tT > fT && tL > fL)
    ) {
      ANG *= -1;
    }
    top -= H / 2;

    line.style["-webkit-transform"] = "rotate(" + ANG + "deg)";
    line.style["-moz-transform"] = "rotate(" + ANG + "deg)";
    line.style["-ms-transform"] = "rotate(" + ANG + "deg)";
    line.style["-o-transform"] = "rotate(" + ANG + "deg)";
    line.style["-transform"] = "rotate(" + ANG + "deg)";
    line.style.top = top + 6 + "px";
    line.style.left = left - 1 + "px";
    line.style.height = H - 12 + "px";
  };

  const setLines = () => {
    if (items && typeof items === "object") {
      let cn = 0;
      let lastData;
      items.map(it => {
        cn++;
        if (cn > 1) {
          adjustLine(
            document.getElementById("ts-vapor-timeline-dot_" + lastData.id),
            document.getElementById("ts-vapor-timeline-dot_" + it.id),
            document.getElementById("ts-vapor-timeline-line_" + lastData.id)
          );
        }
        lastData = it;
        return null;
      });
    }
  };

  const setActivityCompleted = it => {
    dispatch(setFulfilmentActivityCompleted(
      auth,
      it.fulfilmentId,
      it.id,
      main.accountantUuidSelected,
      customerId
    )).then(res => {
      dispatch(displaySuccessToast("Completamento attività in corso, potrebbero volerci alcuni secondi per l'aggiornamento dello stato"));
      setTimeout(() => {
        reloadData();
      }, 1500);
    });
  };

  const renderItems = () => {
    let retItems = [];
    if (items && typeof items === "object") {
      let cn = 0;
      let lastData;
      items.map((it, index) => {
        cn++;
        retItems.push(<div
          id={"ts-vapor-timeline-item_" + it.id}
          key={"ts-vapor-timeline-item_" + index}
          className={
            "ts-vapor-timeline-item" +
              (it.completed ? " completed" : " not-completed") +
              (cn === items.length ? " last" : " not-last") +
              (it.nextToComplete ? " nextToComplete" : "")
          }
        >
          <div
            id={"ts-vapor-timeline-dot_" + it.id}
            key={"ts-vapor-timeline-dot_" + index}
            className="ts-vapor-timeline-item-dot"
          >
            <Tooltip
              color={"rgb(0, 80, 117)"}
              title={
                it.nextToComplete ? (
                  <>
                      Segna l'attività
                    <br />
                      come completata
                  </>
                ) : (
                  ""
                )
              }
            >
              <div
                id={"ts-vapor-timeline-oval_" + it.id}
                key={"ts-vapor-timeline-oval_" + index}
                className="ts-vapor-timeline-item-oval"
                onClick={() => {
                  if (it.nextToComplete) {
                    setActivityCompleted(it);
                  }
                }}
              >
                {it.completed ? (
                  <FontAwesomeIcon icon={["far", "check"]} />
                ) : (
                  <>&nbsp;</>
                )}
              </div>
            </Tooltip>
          </div>
          <div className="ts-vapor-timeline-item-data">
            <div className="ts-vapor-timeline-item-data-tip">
              {it.tip}&nbsp;
            </div>
            <div className="ts-vapor-timeline-item-data-desc">
              {/* FEATURE_TOGGLE_ONLY_DEV && !it.completed && cn < items.length && (
                  <div
                    className="ts-vapor-timeline-item-data-desc-dev"
                    onClick={() => setActivityCompleted(it)}
                  >
                    <FontAwesomeIcon icon={faDev} />
                  </div>
                )*/}
              {it.description}&nbsp;
            </div>
            <div className="ts-vapor-timeline-item-data-subtitle">
              {it.subtitle}&nbsp;
            </div>
          </div>
        </div>);
        if (cn > 1) {
          retItems.push(<div
            id={"ts-vapor-timeline-line_" + lastData.id}
            key={"ts-vapor-timeline-line_" + index}
            className={
              "ts-vapor-timeline-item-line" +
                (lastData.completed ? " completed" : "")
            }
          ></div>);
        }
        lastData = it;
        return null;
      });
    }
    return retItems;
  };

  return <div className="ts-vapor-timeline-root">{renderItems()}</div>;
};

export default VaporTimeline;
